const metricFormatValue = (value: number, precision: number): string =>
	new Intl.NumberFormat(undefined, {
		maximumFractionDigits: Math.max(0, Math.min(20, precision)), // clamp precision between 0 and 20
	}).format(value);

export { metricFormatValue };
